// src/components/Innovation.jsx
import React from "react";
import './chapter.css';
export default function PorteurProjet() {
return (
        <section className="chapter">
    <header className="chapter__header">
        <h2 className="chapter__title">Porteurs de projets d'innovation</h2>
        <p className="chapter__subtitle">
            Génial! Et en plus tu es en Valais ou souhaite venir t'y installer&nbsp;? Tu es plus que le bienvenu dans notre projet dédiés aux investisseurs et porteurs de projets innovants.
        </p>
    </header>




    <div className="chapter__block">
        <h3 className="chapter__block-title">Présentation</h3>
        <p className="chapter__block-text">
            Le projet <br/><a href='https://www.land-of-innovation.ch' target='_blank' rel="noopener noreferrer">Land-Of-Innovation</a><br/> a pour objectif de promouvoir le Valais comme un creuset d'innovation. 
            En chimie, c'est dans le creuset que tout se passe, que les molécules se mélangent pour que les bons alliages se créent. 
            Notre objectif, c'est de te faciliter la tâche en t'apportant au travers de nos partenaires et de nos adhérants, le soutien tant financier que technique pour transformer ton projet en succès.<br/>
            Pour cela nous sommes actuellement en train de sélectionner les meilleures partenaires. 
            Ceux-là même qui vont aplanir ta route, utiliser leur réseau pour te donner plus d'opportunités, plus de visibilité. 
            Nous voulons également te mettre à disposition un certain nombre d'investisseurs, qui seront prêt à investir dans ton projet, 
            parce qu'ils seront rassurés par notre souhait de leur proposer des projets prometteurs, intéressants, et bien préparés.
        </p>
    </div>
    <div className="chapter__block">
        <h3 className="chapter__block-title">Avancement</h3>
        <p className="chapter__block-text">

        <p>Tout cela va se dérouler dans le magnifique écrin qu'est le Valais</p>

        <br/>
        <h3 className="chapter__block-title">En 2025, nous allons acquérir les partenaires pour nous permettre de réaliser ce projet. Grâce à eux d'aller au plus près de l'excellence et de leur permettre d'identifier les premiers projets.</h3>
        <br/>
        <h3 className="chapter__block-title">2026 verra naitre les premiers événements. Cela vous donne le temps de vous préparer.</h3>
        </p>
    </div>


    <div className="chapter__block">
        <h3 className="chapter__block-title">Nos besoins</h3>
        <p className="chapter__block-text">
            Nous recherchons 
        <ul>
            <li>un partenaire coach permettant de te préparer à présenter ton projet en gardant nos investisseurs attentifs et motivés de la première à la dernière présentation.</li>
            <li>un partenaire pour l'organisation de nos événements en Valais. Acceuil, service de support, encadrement et suivi personnalisé de nos investisseurs, service traiteur, transport.</li>
            <li>un partenaire pour la sélection des projets à présenter à chaque événement.</li>
        </ul>
        </p>
    </div>

    <div className="chapter__block">
        <h3 className="chapter__block-title">Contact</h3>
        <p className="chapter__block-text">

            myBusinessPartner
            <br/>
            c/o OnSite-Consulting Sàrl
            <br/>
            Ch. du Mâcheret 29
            <br/>
            1039 La Conversion
            <br/>
        </p>
        <br/>
        <p className="chapter__block-text">Vous avez des questions&nbsp;? Vous souhaitez me rencontrer&nbsp;? Rencontrons-nous dans le cadre des événements de résautage de <a href="https://www.valais-network.ch/evenement/" target="_blank" rel="noopener noreferrer">Valais-Network</a> </p>
    </div>

</section>
        );
}
